import React, { FC } from 'react';
import { BpDesignSystem } from '../../types';
import MuiDrawer, { DrawerProps as MuiDrawerProps } from '@mui/material/Drawer';
import { css, styled } from '../../styles';

const isTestEnv = process.env.NODE_ENV === 'test';

export type DrawerProps = BpDesignSystem.PropsWithChildren<
  MuiDrawerProps & {
    width?: string;
  }
>;

export const Drawer: FC<DrawerProps> = ({ width, dataTest, ...props }) => (
  <StyledDrawer data-test={dataTest} $width={width} disableEnforceFocus={isTestEnv ? true : undefined} {...props} />
);

const StyledDrawer = styled(MuiDrawer)<{ $width?: string }>`
  .MuiDrawer-paper {
    ${({ $width }) => ($width ? css`width: ${$width}` : '')};
  }
`;
